import React from "react";
import {Portlet, PortletHeader,} from "../../../../partials/content/Portlet";

function UserCorporatePersonelTransactions() {

    return (
    <Portlet>
      <PortletHeader title="تراکنش های اعتبار شرکتی کاربر" />

    </Portlet>
  );
}

export default UserCorporatePersonelTransactions;
